/**
 * 属性タイプを現すenum
 */
export enum AttributeType {
  /** 過去属性 */
  History = "過去属性",
  /** リアルタイム属性 */
  RealTime = "リアルタイム属性",
  /** 通常属性 */
  Normal = "通常属性",
  /**静止画属性 */
  Image = "静止画属性",
}

const enumKeys = Object.keys(AttributeType);
const enumValues = Object.values(AttributeType);

/**
 * 属性タイプからenumのkey名を取得
 * @param attributeType 地物タイプ
 */
export const getAttributeTypeKey = (attributeType: string) => {
  const index = enumValues.indexOf(attributeType as AttributeType);
  if (index >= 0) {
    return enumKeys[index] as string;
  }
  return null;
};
